<template>
  <div class="global">
    <!-- <div class="preview">
      <el-button type="success" @click="isShow = true">开始预览</el-button>
    </div> -->
    <div class="pdfContainer" :style="{ width: width }" v-if="isShow">
      <!-- <div class="button">
        <el-button type="success" @click="prev()">上一页</el-button>
        <el-button type="success" @click="next()">下一页</el-button>
        <el-button type="success" @click="scaleD()">放大</el-button>
        <el-button type="success" @click="scaleX()">缩小</el-button>
        <el-button type="success" @click="clockwise()">顺时针</el-button>
        <el-button type="success" @click="antiClockwise()">逆时针</el-button>
      </div> -->
      <div class="pdf">
        <template v-if="numPages">
          <pdf
            ref="pdf"
            v-for="i in numPages"
            :key="i"
            :src="src"
            :page="i"
            style="width: 100%"
          ></pdf>
        </template>

        <template v-else>
          <div class="loading-wrapper">
            <loading :visible="true" :insert="true" style="padding: 10px;" />
          </div>
        </template>

        <!-- <pdf
          ref="pdf"
          :src="src"
          :page="currentPage"
          :rotate="pageRotate"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          @loaded="loadPdfHandler"
        ></pdf> -->
      </div>
      <!-- <div class="page">
        <span class="pageNum">{{ currentPage }}</span>
        <span class="pageNum">/</span>
        <span class="pageNum">{{ pageCount }}</span>
      </div> -->
    </div>
  </div>
</template>
<script>
import Pdf from "vue-pdf";
import loading from "@/components/loading.vue";
import * as pdfjsLib from 'pdfjs-dist';
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";

export default {
  props: {
    downloadUrl: {
      type: String,
      default: ""
    },

    width: {
      type: String,
      default: "80%"
    }
  },
  data() {
    return {
      src: "", // pdf的路径 实际项目后端返回
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      scale: 100, //  开始的时候默认和容器一样大即宽高都是100%
      pageRotate: 0, // 旋转角度
      isShow: true,
      numPages: undefined
    };
  },
  components: { Pdf, loading },
  // beforeRouteEnter(to, from, next) {
  //   // 路由守卫刚刚进入是没有实例化界面的，不能使用this
  //   const queryParam = to.query;
  //   const uu =
  //     "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf";
  //   console.log("uu", uu);
  //   next(vm => {
  //     // vm.src = pdf.createLoadingTask(queryParam.url);
  //     vm.src = pdf.createLoadingTask(uu);
  //     vm.src.promise.then(pdf => {
  //       vm.numPages = pdf.numPages;
  //     });
  //   });
  // },
  mounted() {
    console.log("this.downloadUrl", this.downloadUrl);
    const uu = this.downloadUrl;
    // ||
    // "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf";
    this.src = Pdf.createLoadingTask({
      url: uu,
      CMapReaderFactory: function cMapReaderFactoryExtent() {
        const CMapReader = new CMapReaderFactory();
        this.fetch = function (query) {
          return CMapReader.fetch(query).then((data) => {
            return {
              // 重建一个Uint8Array，修复第二次打开不能显示后端动态添加文字的问题
              cMapData: new Uint8Array(data.cMapData),
              compressionType: data.compressionType,
            };
          });
        };
      },
    });
    this.src.cMapUrl = pdfjsLib.cMapUrl;
    this.src.cMapPacked = pdfjsLib.cMapPacked;
    this.src.promise.then(pdf => {
      console.log("this.pdf", pdf);
      this.numPages = pdf._pdfInfo.numPages;
    }).catch((err) => {
      console.log(err)
    });
  },
  methods: {
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    //  上一页
    prev() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    // 下一页
    next() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    //放大
    scaleD() {
      if (this.scale == 100) return this.$message.warning("已经是最大喽~~");
      this.scale += 10;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    //缩小
    scaleX() {
      if (this.scale == 40) return this.$message.warning("已经是最小喽~~");
      this.scale += -10;
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
      this.$refs.pdf.$el.style.height = parseInt(this.scale) + "%";
    },
    // 顺时针
    clockwise() {
      this.pageRotate += 90;
    },
    // 逆时针
    antiClockwise() {
      this.pageRotate -= 90;
    }
  }
};
</script>
<style scoped>
.global {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.preview {
  width: 100%;
  height: 50px;
}

.pdfContainer {
  width: 100%;
  height: calc(100% - 50px);
  margin: 0 auto;
}
.pdfContainer .button {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdfContainer .pdf {
  width: 100%;
  /* height: calc(100% - 100px); */
  overflow-y: auto;
}
.pdfContainer .page {
  width: 100%;
  height: 50px;
}

.pageNum {
  font-size: 28px;
}

.loading-wrapper {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ProductDetails/pdfPreview.vue